import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { getUsersListToShare, shareProject } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";
import { Project, User } from "interfaces";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonInvite,
  formShareProject,
  modalShareProjcetSubtitle,
  modalShareProjectTitle,
  snackbarEmailSentToSpecifiedEmail,
  snackbarEmailSentToSpecifiedEmails,
  snackbarSummarySuccessSendEmail,
} from "_constants";
import { FormShareProject } from "components/form/FormShareProject";
import {
  setLoadingPanelProjects,
  UpdateProject,
} from "store/slicer/GestioneProjectsSlice";
import { useAppSelector, useAppDispatch } from "store/store";
import { resetFiltersUtenti } from "store/slicer/GestioneUsersSlice";

export const ModalShareProject = ({
  project,
  showDialog = false,
  onClose,
  projectId,
}: {
  project: Project;
  showDialog: boolean;
  onClose: Function;
  projectId?: string;
}) => {
  const [usersList, setUsersList] = useState<any>();
  const currentProject = useAppSelector(
    (state) => state.gestioneProjectsSlice.currentProject
  );
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(showDialog);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      projectId: "",
      userIdsList: [],
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  useEffect(() => {
    dispatch(resetFiltersUtenti());
  }, [dispatch]);

  const getUsersList = useCallback(() => {
    if (project?.id ?? projectId) {
      setValue("projectId", project?.id ?? projectId ?? "");
      getUsersListToShare(project?.id ?? projectId ?? "")
        .then((response) => {
          setUsersList(response.data.usersList);
        })
        .catch((_) => {});
    }
  }, [project.id, projectId, setValue]);

  useEffect(() => {
    getUsersList();
  }, [getUsersList]);

  const updateProject = (usersIdsList: string[]) => {
    const users = usersList.filter((user: User) =>
      user.id ? usersIdsList.includes(user.id) : false
    );
    const tempCurrentProject = JSON.parse(JSON.stringify(currentProject));
    tempCurrentProject.users = users;
    if (users?.length) {
      tempCurrentProject.type = "SHARED";
    }
    dispatch(UpdateProject(tempCurrentProject));
  };

  const onSubmit = (formData: any) => {
    if (formData.userIdsList?.length) {
      shareProject(formData)
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarSummarySuccessSendEmail,
            detail:
              formData.userIdsList?.length > 1
                ? snackbarEmailSentToSpecifiedEmails
                : snackbarEmailSentToSpecifiedEmail,
            life: 5000,
          });
          resetFormState();
          updateProject(formData.userIdsList);
          dispatch(setLoadingPanelProjects(false));
        })
        .catch((_) => {});
    }
  };

  const handleDismiss = () => {
    if (getValues("userIdsList")?.length) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
    onClose();
  };

  const stopPropagation = (e: any) => {
    e.stopPropagation();
  };

  return (
    <div onClick={(e) => stopPropagation(e)}>
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="700px"
        width="700px"
        header={
          <SingleStepHeaders
            title={modalShareProjectTitle}
            subtitle={modalShareProjcetSubtitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formShareProject}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100 height-100"
              >
                <FormShareProject
                  control={control}
                  usersList={usersList}
                  setValue={setValue}
                  getValues={getValues}
                />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter
            dismiss={handleDismiss}
            form={formShareProject}
            labelSubmit={buttonInvite}
          />
        }
        display={visible}
        setVisible={setVisible}
      />
    </div>
  );
};
